// 所有请求接口导入vuex
import apis from "@/api/index";

const store = {
	state: {},
	getters: {},
	mutations: {},
	actions: {
		...apis,
	},
};
export default store;
